import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Julia hat ein unglaubliches Gespür dafür, Menschen authentisch einzufangen. Die Fotos haben meine Website auf ein neues Level gehoben und ich bekomme ständig Komplimente dafür.',
    author: 'Sarah Weber',
    role: 'Gründerin, Weber Consulting'
  }, {
    quote: 'Ich stehe eigentlich ungern vor der Kamera, aber Julia hat mir durch ihre lockere Art sofort die Nervosität genommen. Das Ergebnis sind Bilder, auf denen ich mich wirklich wiedererkenne.',
    author: 'Markus Lang',
    role: 'Architekt'
  }, {
    quote: 'Professionell, kreativ und super sympathisch. Das Branding-Shooting war eine der besten Investitionen für mein Business dieses Jahr. Absolute Empfehlung!',
    author: 'Lisa Bauer',
    role: 'Fitness Coach'
  }];
  return <section className="py-20 bg-white" data-id="element-118">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-16" data-id="element-120">
          Das sagen meine Kunden
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-121">
          {testimonials.map((item, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg relative" data-id="element-122">
              <Quote className="absolute top-6 left-6 h-8 w-8 text-[#D4A574]/20" data-id="element-123" />
              <div className="relative z-10" data-id="element-124">
                <p className="text-gray-600 italic mb-6 pt-4" data-id="element-125">"{item.quote}"</p>
                <div className="flex items-center" data-id="element-126">
                  <div className="h-10 w-10 rounded-full bg-[#D4A574] flex items-center justify-center text-white font-bold text-lg mr-3" data-id="element-127">
                    {item.author.charAt(0)}
                  </div>
                  <div data-id="element-128">
                    <p className="font-bold text-gray-900" data-id="element-129">{item.author}</p>
                    <p className="text-sm text-gray-500" data-id="element-130">{item.role}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}